import { HeroArtwork } from '../components/HeroArtwork';
import { HeroBackground } from '../components/HeroBackground';
import { BrandMark } from '../components/BrandMark';
import { SnapNav } from '../components/SnapNav';
import './LandingPage.css';

export function LandingPage(): JSX.Element {
  return (
    <div className="lp-root">
      <header className="lp-nav">
        <a href="/" className="lp-brand" aria-label="Street Forensic Services — Home">
          <BrandMark />
        </a>
        <nav className="lp-nav-links">
          <a href="#services">Services</a>
          <a href="#about">About Us</a>
          <a href="#contact">Contact</a>
          <a href="#contact" className="lp-cta-cyan-sm">Get a Consultation</a>
        </nav>
      </header>

      {/* Panel 1 — Hero */}
      <section className="lp-panel lp-hero">
        <HeroBackground />
        <div className="lp-hero-grid">
          <div className="lp-hero-copy">
            <h1 className="lp-hero-title">
              Precision in
              <br />
              Digital <span className="lp-accent">Discovery</span>
            </h1>
            <p className="lp-hero-sub">
              Advanced cyber forensic solutions for the modern world.
            </p>

            <div className="lp-cta-row lp-cta-row-secondary">
              <a href="#services" className="lp-btn-outline">Explore Our Services</a>
              <a href="#contact" className="lp-btn-outline">Get in Touch</a>
            </div>
          </div>

          <div className="lp-hero-art">
            <HeroArtwork />
          </div>
        </div>
      </section>

      {/* Panel 2 — Services */}
      <section id="services" className="lp-panel lp-section">
        <div className="lp-panel-inner">
          <h2 className="lp-section-title">Services</h2>
          <div className="lp-card-grid">
            {SERVICES.map((s) => (
              <article key={s.title} className="lp-card">
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Panel 3 — About + Contact */}
      <section id="about" className="lp-panel lp-section lp-section-alt">
        <div className="lp-panel-inner lp-ac-grid">
          <div className="lp-about">
            <h2 className="lp-section-title">About Us</h2>
            <p>
              Street Forensic Services is a digital-forensics and security
              consultancy. We help legal teams, corporate clients, and incident
              responders preserve, analyze, and present digital evidence with
              chain-of-custody rigor that holds up in court.
            </p>
            <p>
              Every engagement is hash-verified and delivered with documentation
              a non-technical jury can follow.
            </p>
          </div>

          <div id="contact" className="lp-contact">
            <h2 className="lp-section-title">Get a Consultation</h2>
            <p className="lp-contact-lead">
              Tell us about your matter. We'll respond within one business day
              with engagement options and an indicative timeline.
            </p>
            <div className="lp-contact-grid">
              <a className="lp-contact-card" href="mailto:contact@stfors.com">
                <span className="lp-contact-label">Email</span>
                <span className="lp-contact-value">contact@stfors.com</span>
              </a>
              <a className="lp-contact-card" href="tel:+13016512553">
                <span className="lp-contact-label">Phone</span>
                <span className="lp-contact-value">(301) 651-2553</span>
              </a>
            </div>
          </div>

          <footer className="lp-footer">
            <div className="lp-footer-inner">
              <div className="lp-footer-brand">
                <BrandMark small />
              </div>
              <span className="lp-footer-copy">
                &copy; {new Date().getFullYear()} Street Forensic Services · All
                rights reserved
              </span>
            </div>
          </footer>
        </div>
      </section>

      <SnapNav />
    </div>
  );
}

const SERVICES = [
  {
    title: 'Digital Forensics',
    body: 'Mobile, computer, and cloud acquisition with hash-verified imaging and full chain of custody documentation.',
  },
  {
    title: 'E-Discovery',
    body: 'Litigation-ready collection, processing, and production. Privileged-document review workflows built in.',
  },
  {
    title: 'Expert Testimony',
    body: 'Court-qualified examiners who translate forensic findings into language judges and juries actually follow.',
  },
];
